export default function extractRawElm($elm) {
  return $elm.length === 1 ? $elm[0] : $elm
}
